import { useCreateMachine } from 'fsm';
import { useEffect, useCallback } from 'react';
import { useGridList } from '../useGridList';
import { refreshProgressMachine } from './machine';
export const useRefreshProgress = () => {
  const {
    isRefreshing
  } = useGridList();
  const machine = useCreateMachine(refreshProgressMachine, {
    initialContext: {
      progressValue: 0,
      isRefreshing: isRefreshing || false
    }
  });
  const {
    state,
    send
  } = machine;
  useEffect(() => {
    if (!state.isRunning()) {
      return;
    }
    if (isRefreshing && state.matches('idle')) {
      send({
        type: 'START_REFRESHING'
      });
    } else if (!isRefreshing && (state.matches('animating') || state.matches('delaying'))) {
      send({
        type: 'STOP_REFRESHING'
      });
    }
  }, [isRefreshing, send, state]);
  const updateProgress = useCallback(value => {
    if (state.isRunning() && state.matches('animating') && value !== state.context.progressValue) {
      setTimeout(() => {
        send({
          type: 'UPDATE_PROGRESS',
          value
        });
      }, 0);
    }
  }, [state, send]);
  return {
    isVisible: state.hasTag('visible'),
    progressValue: state.context.progressValue,
    updateProgress
  };
};